/* global axios */

const BASE = '/api/v1/ardhisasa';

const authHeaders = (token, jwt) => ({
  'X-Ardhisasa-Token': token,
  'X-Ardhisasa-Jwt': jwt,
});

// Provision Chatwoot user from Ardhisasa credentials
export const provisionChatwoot = (
  accessToken,
  jwt,
  email,
  name,
  { firstname, lastname, profilePhoto, ardhisasaUsername } = {}
) =>
  axios.post(`${BASE}/provision_chatwoot`, {
    access_token: accessToken,
    jwt,
    email,
    name,
    firstname,
    lastname,
    profile_photo: profilePhoto,
    ardhisasa_username: ardhisasaUsername,
  });

// Auth
export const login = (username, password) =>
  axios.post(`${BASE}/auth/login`, { username, password });

export const verifyOtp = (username, password, otpcode) =>
  axios.post(`${BASE}/auth/otp_verify`, { username, password, otpcode });

export const refreshToken = (token, jwt, refreshTkn) =>
  axios.post(
    `${BASE}/auth/refresh_token`,
    { refresh_token: refreshTkn },
    { headers: authHeaders(token, jwt) }
  );

// Self-service password change (requires an active Ardhisasa session)
export const requestPasswordUpdate = (token, jwt, currentPassword) =>
  axios.post(
    `${BASE}/auth/request_password_update`,
    { current_password: currentPassword },
    { headers: authHeaders(token, jwt) }
  );

export const changeArdhisasaPassword = (
  token,
  jwt,
  { currentPassword, password, passwordConfirm, otpCode }
) =>
  axios.post(
    `${BASE}/auth/change_password`,
    {
      current_password: currentPassword,
      password,
      passwordconfirm: passwordConfirm,
      otp_code: otpCode,
    },
    { headers: authHeaders(token, jwt) }
  );

// Tickets
export const listTickets = (
  token,
  jwt,
  filterType,
  page,
  search = '',
  sortOrder = 'desc'
) =>
  axios.get(`${BASE}/tickets`, {
    headers: authHeaders(token, jwt),
    params: { filter_type: filterType, page, search, sort_order: sortOrder },
  });

export const getTicketDetail = (token, jwt, requestId) =>
  axios.get(`${BASE}/tickets/detail`, {
    headers: authHeaders(token, jwt),
    params: { request_id: requestId },
  });

export const createTicket = (token, jwt, payload) =>
  axios.post(`${BASE}/tickets/raise`, payload, {
    headers: authHeaders(token, jwt),
  });

export const createAnonymousTicket = (token, jwt, payload) =>
  axios.post(`${BASE}/tickets/anonymous`, payload, {
    headers: authHeaders(token, jwt),
  });

// Lookup endpoints
export const getCustomerTypes = (token, jwt) =>
  axios.get(`${BASE}/lookups/customer_types`, {
    headers: authHeaders(token, jwt),
  });

export const getIdentificationTypes = (token, jwt) =>
  axios.get(`${BASE}/lookups/identification_types`, {
    headers: authHeaders(token, jwt),
  });

export const getEntities = (token, jwt) =>
  axios.get(`${BASE}/lookups/entities`, { headers: authHeaders(token, jwt) });

export const getDepartments = (token, jwt, ministryId) =>
  axios.get(`${BASE}/lookups/departments`, {
    headers: authHeaders(token, jwt),
    params: { ministry_id: ministryId },
  });

export const getSections = (token, jwt, departmentId) =>
  axios.get(`${BASE}/lookups/sections`, {
    headers: authHeaders(token, jwt),
    params: { department_id: departmentId },
  });

export const getChannelSources = (token, jwt) =>
  axios.get(`${BASE}/lookups/channel_sources`, {
    headers: authHeaders(token, jwt),
  });

export const getCustomerCareDepartment = (token, jwt) =>
  axios.get(`${BASE}/lookups/customer_care_department`, {
    headers: authHeaders(token, jwt),
  });

export const getStaffDesignations = (token, jwt, departmentId) =>
  axios.get(`${BASE}/lookups/staff_designations`, {
    headers: authHeaders(token, jwt),
    params: { department_id: departmentId },
  });

export const getCounties = (token, jwt, search = '') =>
  axios.get(`${BASE}/lookups/counties`, {
    headers: authHeaders(token, jwt),
    params: { search },
  });

export const getRegistries = (token, jwt, countyId) =>
  axios.get(`${BASE}/lookups/registries`, {
    headers: authHeaders(token, jwt),
    params: { county_id: countyId },
  });
